import { render, staticRenderFns } from "./SearchPageBrowseByLinks.vue?vue&type=template&id=f3d0142c&scoped=true"
import script from "./SearchPageBrowseByLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPageBrowseByLinks.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d0142c",
  null
  
)

export default component.exports